import axiosInstance from '../utils/axiosInstance';
import type { Matter } from '../../types/matter';

interface CreateMatterResponse {
  success: boolean;
  data: { matterId: string; ref: string };
}

export const createMatter = async (): Promise<{ matterId: string; ref: string }> => {
  const response = await axiosInstance.post<CreateMatterResponse>('/matters/create', {});
  return response.data.data;
};
